module.exports = __webpack_public_path__ + "media/src/images/icon/fa-fb-b17838b5d7955840f0a31c35186f7911.png";